import * as Sentry from '@sentry/nuxt'

import type { AmplitudeOptions } from '@brighterly/lib-core-types/tools/amplitude/interfaces'
import type { Options } from '@amplitude/marketing-analytics-browser/lib/esm/typings/browser-client'

import { useTutorApplicationStore } from '@features/apply-for-position'
import { amplitude, setAmplitudeUserProperty } from '@shared/lib/amplitude'
import { isObject } from '@shared/lib/object'
import { getQueryParamsObject } from '@shared/lib/query'

import { useToolsStore } from './store'

export const initAmplitude = (options: AmplitudeOptions = {}): void => {
  const toolsStore = useToolsStore()

  const runtimeConfig = useRuntimeConfig().public
  const apiKey = runtimeConfig.amplitudeApiKey ?? ''
  const env = runtimeConfig.environment
  const serverUrl = runtimeConfig.amplitudeServerUrl

  if (!apiKey) {
    console.error('Error in method initAmplitude: amplitudeApiKey is not defined.')
  } else {
    if (!toolsStore.analyticsFirstSuccessInit) {
      setAmplitudeUserProperty('environment', env || '')
      setAmplitudeUserProperty('user_type', 'candidate')

      const queryParams = getQueryParamsObject() as Record<string, string>
      if (isObject(queryParams)) {
        Object.entries(queryParams).forEach(([key, value]) => {
          if (value) {
            setAmplitudeUserProperty(key, value)
          }
        })
      }
    }

    const baseOptions: Options = {
      pageViewTracking: true,
      deviceId: options.deviceId || undefined,
    }

    if (serverUrl) {
      baseOptions.serverUrl = serverUrl
    }

    amplitude.init(
      apiKey,
      options.userId || undefined,
      baseOptions,
    )
      .promise
      .then((): void => {
        toolsStore.setAnalyticsFirstSuccessInit(true)
        const amplitudeId = options.deviceId || amplitude.getDeviceId()
        const amplitudeUrl = `https://app.amplitude.com/analytics/skelar/project/472284/search/${amplitudeId}`
        const tutorApplicationStore = useTutorApplicationStore()
        tutorApplicationStore.setAmplitudeId(amplitudeId || '')
        if (!toolsStore.analyticsFirstSuccessInit) {
          const dsn = useRuntimeConfig().public.sentryDsn
          if (dsn) {
            Sentry.setUser({
              amplitude_url: amplitudeUrl,
            })
          }
        }
      })
      .catch((): void => {
        const timeout = setTimeout(() => {
          initAmplitude(options)
          clearTimeout(timeout)
        }, 800)
      })
  }
}
